import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { EngagementMeetingAvailabilityBlockContract } from '../models/engagement-meeting-availability-block-contract';

export const FetchEngagementAvailabilityBlocks = createAsyncThunk(
    'engagementMeetings/fetchAvailabilityBlocks',
    async (engagementId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/Marketplace/Engagements/${engagementId}/EngagementMeetingAvailabilityBlocks`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch availability blocks at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch availability blocks');
            }

            return response.data as EngagementMeetingAvailabilityBlockContract[];
        } catch (error) {
            createNotification(
                'An error occurred while fetching availability blocks.',
                'error'
            );
            throw error;
        }
    }
);

